// extracted by mini-css-extract-plugin
module.exports = {"footerAddFiles":"styles_footerAddFiles__2CG-s","containerFilesQueue":"styles_containerFilesQueue__2W4kb","gridUploadFiles":"styles_gridUploadFiles__1oXkK"};